import React, {useEffect, useCallback, useState} from "react";
import { NumericFormat } from 'react-number-format';

import { Input } from "reactstrap";
import EmojiButtons from "./EmojiButtons";
import {ContentTemplatePayload, ContentTemplateType} from "../redux/Content/Template/types";
import TemplateButton from "./TemplateButton";
import InputSelect from "./InputSelect";
import {useRedux} from "../hooks";
import {showRightModalContentTemplates} from "../redux/Content/Template/actions";
import '../i18/config';
import {useTranslation} from "react-i18next";
import AIGenerateButton from "./AIGenerateButton";
import {aiTextGenerateOpenModal} from "../blocks/AI/TextGenerate/TextGenerateActions";

interface InputTextareaProps {
    id: string;
    placeholder: null | string
    value: null | string;
    onChange: (value: string) => void;
    maxLength?: number;
    templates?: Array<ContentTemplateType>
    isAddToTemplate?: true | boolean
    isShowEmoji?: true | boolean
    isShowAITextGenerate: false | boolean
}
const InputEmojiArea = ({ id, placeholder, value, onChange, maxLength, templates, isAddToTemplate, isShowEmoji, isShowAITextGenerate }: InputTextareaProps) => {
    const { dispatch } = useRedux();
    const { t } = useTranslation(['template']);
    const [text, setText] = useState<string>(value || '');
    const [isShowTemplate, setShowTemplate] = useState<boolean>(false);
    const [caretPosition, setCaretPosition] = useState<number>(0);

    const onChangeText = useCallback((newText: string) => {
        setText(newText);
        onChange(newText);
    }, [onChange]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    const onChangeShowTemplate = useCallback(() => {
        setShowTemplate(prev => !prev);
    }, []);

    const onTemplateSelect = useCallback((item: any) => {
        if (item.value !== undefined && templates) {
            const templateItem = templates.find(t => t.uuid === item.value);
            if (templateItem) {
                const updatedText = text ? `${text} ${templateItem.text}` : templateItem.text;
                onChangeText(updatedText);
            }
        }
    }, [templates, text, onChangeText]);

    const isShowToolbar = isShowEmoji || isShowAITextGenerate || (templates && templates.length > 0 && isShowTemplate);

    const handleAddToTemplate = useCallback(() => {
        const newTemplate: ContentTemplateType = {
            enabled: true,
            name: '',
            text: text
        };
        const contentTemplatePayload: ContentTemplatePayload = {
            data: newTemplate,
            modalEditTitle: 'newTemplate'
        };
        dispatch(showRightModalContentTemplates(contentTemplatePayload));
    }, [dispatch, text]);

    const handleAITextGenerate = useCallback(() => {
        aiTextGenerateOpenModal({ text }, dispatch);
    }, [dispatch, text]);

    const handleCaretPosition = useCallback((event: any) => {
        setCaretPosition(event.target.selectionStart);
    }, []);

    const textLength = text?.length || 0;

  return (
      <>
          <div className="position-relative">
              {isShowToolbar && (
                  <div className="rightToolBarCont d-flex flex-column">
                      {isShowEmoji && (
                          <div className="mb-1">
                              <EmojiButtons
                                  text={text}
                                  onChange={onChangeText}
                                  cursorPosition={caretPosition}
                              />
                          </div>
                      )}
                      {templates && templates.length > 0 && (
                          <div className="mb-1">
                              <TemplateButton onChange={onChangeShowTemplate} />
                          </div>
                      )}
                      {isShowAITextGenerate && (
                          <div className="mb-1">
                              <AIGenerateButton onChange={handleAITextGenerate} />
                          </div>
                      )}
                  </div>
              )}
              <div className={isShowToolbar ? 'rightToolBarEditorMargin' : ''}>
                  <Input
                      type="textarea"
                      id={id}
                      placeholder={placeholder}
                      value={text}
                      onChange={(e: any) => onChangeText(e.target.value)}
                      onKeyUp={handleCaretPosition}
                      onMouseUp={handleCaretPosition}
                      autoComplete="off"
                      rows={7}
                  />
                  <div className="lengthCount text-muted fs-10 d-flex flex-row flex-nowrap justify-content-end">
                        <span className="colorBlue">
                            <NumericFormat thousandSeparator={' '} displayType={'text'} value={textLength} />
                        </span>
                      {maxLength && (
                          <span className="text-muted ms-2">
                                <NumericFormat thousandSeparator={' '} displayType={'text'} value={maxLength} />
                            </span>
                      )}
                  </div>
              </div>
          <div className="d-flex flex-row flex-nowrap flex-grow-1">
              <div className="d-flex flex-row flex-grow-1">
                  {isAddToTemplate &&
                  <a className="colorBlue fs-10" onClick={handleAddToTemplate}>+{" "}{t('template:toTemplates')}</a>
                  }
              </div>
          </div>
          {isShowTemplate &&
              <InputSelect
                  items={templates}
                  placeholder={t('template:chooseTemplate')}
                  onChange={onTemplateSelect}
                  required={false}
              />
          }
          </div>
      </>
  );
};
export default InputEmojiArea;
